export { BirthdaysModule } from './birthdays.module';
